module.exports = __webpack_public_path__ + "static/media/banner-paquetes.4fa3cc0c.jpg";